// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"5ed5e654","62":"03108b25","120":"6eeb60f4","359":"a6550ed8","443":"6054e599","453":"a21f0e99","548":"d1902df7","686":"9c968877","765":"5a77e54b","882":"da72ef5e","900":"0678d161","977":"2c1a2d6a"}[chunkId] + ".chunk.js";
};